import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ProductCard = makeShortcode("ProductCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="light" className='titleBlock-align-left' mdxType="TitleBlock" />
    <h2 {...{
      "id": "explore-other-adobe-document-services-apis"
    }}>{`Explore other Adobe Document Services APIs`}</h2>
    <ProductCard slots="icon, heading, text, buttons" theme="light" width="33%" className="product-card-compact-img product-card-compact-img-service" mdxType="ProductCard" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/d6d113f40c8c91f8b838d909d7371089/create_secure_support.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h4 {...{
      "id": "services"
    }}>{`Services`}</h4>
    <p>{`Create a PDF from Microsoft Office documents, protect the content, and export to other formats.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Learn more`}</a></li>
    </ul>
    <ProductCard slots="icon, heading, text, buttons" theme="light" width="33%" className="product-card-compact-img product-card-compact-img-service" mdxType="ProductCard" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/efe2408969817562c94b7f0dfd2704f8/Extract-v2.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "extract"
    }}>{`Extract`}</h3>
    <p>{`Extract text, tables, images, and document structure.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-extract.md"
        }}>{`Learn more`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.com/go/extract_visualizer"
        }}>{`Demo`}</a></li>
    </ul>
    <ProductCard slots="icon, heading, text, buttons" theme="light" width="33%" className="product-card-compact-img product-card-compact-img-service" mdxType="ProductCard" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/4df833320f3bc6d456351a3b3da97373/customizable_experience.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "embed"
    }}>{`Embed`}</h3>
    <p>{`Embed high-fidelity PDFs in web apps with analytics.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Learn more`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/view-sdk-demo/index.html#/view/FULL_WINDOW/Bodea%20Brochure.pdf"
        }}>{`Demo`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      